import { render, staticRenderFns } from "./IconApple.vue?vue&type=template&id=4d7a7e20&scoped=true&"
import script from "./IconApple.vue?vue&type=script&lang=js&"
export * from "./IconApple.vue?vue&type=script&lang=js&"
import style0 from "./IconApple.vue?vue&type=style&index=0&id=4d7a7e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7a7e20",
  null
  
)

export default component.exports